import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import Typography from "@material-ui/core/Typography"
import { FormattedMessage } from "react-intl"
import { BLOCKS, MARKS } from "@contentful/rich-text-types"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"

import backgroundImg from "./backgroundImg.svg"

const useStyles = makeStyles(theme => ({
  container: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    alignItems: "center",
  },
  banner: {
    height: "300px",
    zIndex: "1",
    width: "100vw",
    backgroundColor: theme.palette.invertedGreen.support,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  },
  bannerText: {
    position: "relative",
    color: theme.palette.green.main,
    fontSize: theme.spacing(5.5),
    letterSpacing: theme.spacing(0.5),
    fontFamily: theme.typography.fontFamily,
    [theme.breakpoints.down("md")]: {
      textAlign: "center",
    },
  },
  backgroundImg: {
    position: "absolute",
    zIndex: "-1",
    width: "350px",
    left: "15%",
    top: theme.spacing(18.1),
    color: "red",
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  accorContainer: {
    width: "80%",
    maxWidth: theme.spacing(90),
    marginTop: theme.spacing(10),
    position: "relative",
  },
  heading: {
    textAlign: "center",
  },
  title: {
    fontWeight: "bold",
  },

  // Rich text styling

  bold: { fontWeight: "bold" },
  italic: { fontStyle: "italic" },
  text: {
    fontSize: theme.spacing(2),
    color: theme.palette.tertiary.main,
    textAlign: "justify",
  },
  link: { color: theme.palette.green.main },
}))

const TermsofUse = props => {
  const Bold = ({ children }) => (
    <span className={classes.bold}>{children}</span>
  )
  const Italic = ({ children }) => (
    <span className={classes.italic}>{children}</span>
  )
  const Text = ({ children }) => <p className={classes.text}>{children}</p>
  const Link = ({ children }) => (
    <span className={classes.link}>{children}</span>
  )

  const options = {
    renderMark: {
      [MARKS.BOLD]: text => <Bold>{text}</Bold>,
      [MARKS.ITALIC]: text => <Italic>{text}</Italic>,
    },
    renderNode: {
      [BLOCKS.PARAGRAPH]: (node, children) => <Text>{children}</Text>,
      [BLOCKS.HYPERLINK]: (node, children) => <Link>{children}</Link>,
    },
  }

  const classes = useStyles()
  const termsOfUse = props.termsOfUse
  
  return (
    <div className={classes.container}>
      <div className={classes.banner}>
        <Typography variant={"h1"} classes={{ root: classes.bannerText }}>
          <FormattedMessage id="termsOfUse" />
        </Typography>
        <img src={backgroundImg} className={classes.backgroundImg} alt="" />
      </div>

      <div className={classes.accorContainer}>
        <div className={classes.heading}>
          <Typography className={classes.title}>
            {props.termsOfUse.node.title}
          </Typography>

          <Typography>
            <span>
              <FormattedMessage id="lastUpdated" />{" "}
            </span>
            <span>{props.termsOfUse.node.lastUpdatedAt}</span>
          </Typography>
        </div>

        {documentToReactComponents(
          props.termsOfUse.node.richContent.json,
          options
        )}
      </div>
    </div>
  )
}

export default TermsofUse
